import {connect} from 'react-redux';

import GiftCard from './gift-card';
import { fetchPrices } from '../product/product-actions';
import {Helpers} from '../core/src/helpers';

// Convenience component to display product price with just the product. Wire in product price catalog and user from store directly

function mapStateToProps(state, ownProps) {
    const price = Helpers.getProductPrice(ownProps.product, state.productData.productInfo.productPrices);
    
    return {
        price
    }
}

const mapDispatchToProps = dispatch => {
	return {
		fetchPrices: (id) => dispatch(fetchPrices([id]))
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(GiftCard);
